module.exports = __webpack_public_path__ + "img/home-nav-fz-icon.c3eca6d7.png";